import * as yup from 'yup'
import { TDecision } from './types'

export const RulesManualReviewModalSchema = yup.object({
  decision: yup.mixed<TDecision>().oneOf(['pass', 'fail', 'incomplete']),
  rules: yup.array().of(yup.string()),
})

export type TRulesManualReviewModalSchema = yup.InferType<typeof RulesManualReviewModalSchema>
